import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e74612e6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-full h-full flex flex-col items-center" }
const _hoisted_2 = { class: "content w-full h-full flex-1 flex justify-between" }
const _hoisted_3 = { class: "team-list" }
const _hoisted_4 = { class: "team-list" }
const _hoisted_5 = { class: "w-full text-center text-white font-normal bottom-btn" }
const _hoisted_6 = {
  key: 0,
  class: "flex justify-between"
}
const _hoisted_7 = {
  key: 1,
  class: "w-full flex justify-between items-center"
}

import { ref, reactive, onMounted } from "vue";
import API from "@/api/peopleTeam/index.api"
import WaitBoardCard from "./page/WaitBoardCard.vue";
import onWorkCard from "./page/onWorkCard.vue";
import onChooseCard from "./page/onChooseCard.vue";
import mittBus from './constant/Bus'
import { logout } from "@/constant/index"
import APIlogout from "@/api/login/index"
import { IGetMachineTeamFindWorkingEmployeesVo } from "@/api/peopleTeam";
import { message } from "ant-design-vue";
//定义生命周期事件

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

onMounted(() => {
  if (!localStorage.getItem("pageName")) {
    btnState.value = false
    onWorkStatue.value = true
  }
});
const btnState = ref<boolean>(true)
const onWorkStatue = ref<boolean>(false)
const performanceStatue = ref<boolean>(false)
const offWorkStatue = ref<boolean>(false)
const allParmar = reactive({
  factorParmas: [] as any[],//系数修改人员列表
  onWorkParmas: [] as any[],//上机人员选择列表
  offWorkParmas: [] as any[],//下机人员选择列表,
  chooseList: [] as any[]//已选择人员列表
})
//系数修改人员
const factorChange = (data: IGetMachineTeamFindWorkingEmployeesVo) => {
  if (allParmar.factorParmas.length > 0) {
    if (allParmar.factorParmas.findIndex((val) => val.employeeId == data.workingEmployeesId) !== -1) {
      let index = allParmar.factorParmas.findIndex((val) => val.employeeId == data.workingEmployeesId);
      allParmar.factorParmas[index].coefficient = Number(data.coefficient)
    } else {
      allParmar.factorParmas.push({ employeeId: data.workingEmployeesId, coefficient: Number(data.coefficient) })
    }
  } else {
    allParmar.factorParmas.push({ employeeId: data.workingEmployeesId, coefficient: Number(data.coefficient) })
  }
}
//上机选择人员
const onWorkChooseList = (data: any) => {
  allParmar.onWorkParmas = []
  data.map(item => {
    allParmar.onWorkParmas.push({ userId: item.employeesId, coefficient: item.coefficient })
  });
}
//下机选择人员
const offWorkChooseList = ((data: any) => {
  if (offWorkStatue.value) {
    allParmar.offWorkParmas = []
    data.forEach((ele: { workingEmployeesId: number; }) => {
      allParmar.offWorkParmas.push(ele.workingEmployeesId)
    })
  }
})

const save = () => {
  if (performanceStatue.value) {
    //修改系数
    API.postMachineTeamAdjustedEmployeesCoefficient(allParmar.factorParmas).then((res) => {
      message.success({ content: "修改系数成功" });
      btnState.value = true
      performanceStatue.value = false
      allParmar.factorParmas = []
    }, (error) => {
      if (error.code == '000307009') {
        APIlogout.logout().then((res) => {
          logout()
        })
      } else if (error.code == '000307008') {
        btnState.value = true
        performanceStatue.value = false
        allParmar.factorParmas = []
      }
    }
    )
  } else if (offWorkStatue.value) {
    //下机
    API.postMachineTeamOffMachine(allParmar.offWorkParmas).then((res) => {
      message.success({ content: "下机成功" });
      mittBus.emit('updataDate', true)
      cancel()
    }, (error) => {
      if (error.code == '000307009') {
        APIlogout.logout().then((res) => {
          logout()
        })
      } else if (error.code == '000307008') {
        mittBus.emit('updataDate', true)
        cancel()
      }
    }
    )
  } else if (onWorkStatue.value) {
    //上机
    API.postMachineTeamOnMachine(allParmar.onWorkParmas).then((res) => {
      onWorkStatue.value = false
      btnState.value = true
      allParmar.onWorkParmas = []
      message.success({ content: "上机成功" });
    }, (error) => {
      if (error.code == '000307009') {
        APIlogout.logout().then((res) => {
          logout()
        })
      } else if (error.code == '000307008') {
        cancel()
      }
    }
    )
  }
}
//重置状态
const cancel = () => {
  btnState.value = true
  onWorkStatue.value = false
  performanceStatue.value = false
  offWorkStatue.value = false
  allParmar.onWorkParmas = []
  allParmar.offWorkParmas = []
  allParmar.factorParmas = []
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (offWorkStatue.value)
          ? (_openBlock(), _createBlock(onWorkCard, {
              key: 0,
              offWorkBtn: offWorkStatue.value,
              onOffWorkChooseList: offWorkChooseList
            }, null, 8, ["offWorkBtn"]))
          : (_openBlock(), _createBlock(WaitBoardCard, {
              key: 1,
              onWorkBtn: onWorkStatue.value,
              onOnWorkChooseList: onWorkChooseList
            }, null, 8, ["onWorkBtn"]))
      ]),
      _createElementVNode("div", _hoisted_4, [
        (onWorkStatue.value || offWorkStatue.value)
          ? (_openBlock(), _createBlock(onChooseCard, {
              key: 0,
              onWorkStatue: onWorkStatue.value,
              offWorkStatue: offWorkStatue.value,
              list: allParmar.chooseList
            }, null, 8, ["onWorkStatue", "offWorkStatue", "list"]))
          : (_openBlock(), _createBlock(onWorkCard, {
              key: 1,
              onFactorChange: factorChange,
              editPerformanceBtn: performanceStatue.value,
              onWorkBtn: onWorkStatue.value
            }, null, 8, ["editPerformanceBtn", "onWorkBtn"]))
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      (btnState.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", {
              class: "btnList",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (onWorkStatue.value = true, btnState.value = false))
            }, "上机"),
            _createElementVNode("div", {
              class: "btnList",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (performanceStatue.value = true, btnState.value = false))
            }, "修改绩效"),
            _createElementVNode("div", {
              class: "btnList",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (offWorkStatue.value = true, btnState.value = false))
            }, "下机")
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("button", {
              onClick: cancel,
              class: "edit-button cancel"
            }, "取消"),
            _createElementVNode("button", {
              onClick: save,
              class: "edit-button"
            }, "确定")
          ]))
    ])
  ]))
}
}

})